import { useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';
import './Profile.css';

const ROLE_LABELS = {
  read: 'Read',
  write: 'Write',
  admin: 'Admin',
};

function Profile({ currentUser, onUserUpdate }) {
  const [firstName, setFirstName] = useState(currentUser?.firstName ?? '');
  const [lastName, setLastName] = useState(currentUser?.lastName ?? '');
  const [saving, setSaving] = useState(false);
  const [savedMessage, setSavedMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSavedMessage(null);
    try {
      const res = await api.put(`${QUALITY_SERVICE_API_URL}/hub/users/me`, { firstName, lastName });
      onUserUpdate(res.data);
      setSavedMessage('Profile saved.');
    } catch {
      setError('Failed to save profile. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="application-container">
      <div className="profile-page">
        <h1 className="profile-title">Profile</h1>
        <form className="profile-form" onSubmit={handleSubmit}>
          <div className="profile-field">
            <label className="profile-label">Email</label>
            <span className="profile-value">{currentUser?.email}</span>
          </div>
          <div className="profile-field">
            <label className="profile-label">Role</label>
            <span className="profile-value">{ROLE_LABELS[currentUser?.hubRole] ?? currentUser?.hubRole}</span>
          </div>
          <div className="profile-field">
            <label className="profile-label" htmlFor="firstName">First name</label>
            <input
              id="firstName"
              className="profile-input"
              type="text"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
          </div>
          <div className="profile-field">
            <label className="profile-label" htmlFor="lastName">Last name</label>
            <input
              id="lastName"
              className="profile-input"
              type="text"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
          </div>
          {error && <p className="profile-error">{error}</p>}
          {savedMessage && <p className="profile-saved">{savedMessage}</p>}
          <button className="profile-save-btn" type="submit" disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Profile;
